export default () => ({
  workers: null,
  worker: null,
  links: null,
  meta: null,
  hasData: false,
});
